import React, { useState, useEffect } from "react";
import { translate } from "../Services/translation";

class SearchLoadMore extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: 6,
      error: false,
    };

    this.loadMore = this.loadMore.bind(this);
  }

  loadMore() {
    this.setState((prev) => {
      return { visible: prev.visible + 6 };
    });
  }

  render() {
    const { values } = this.props;
    return (
      <div className="other-hits__list-page">
        <div className="other-hits__items row-inner" aria-live="polite">
          {values.slice(0, this.state.visible).map((value, index) => {
            return (
              <div
                className="pagelist__item columns small-12 medium-6 large-4 fade-in"
                key={`item${index}`}
              >
                <a href={value.url} className="pagelist__item--url">
                  <div className="pagelist__item--background">
                    <div className="pagelist__item--image-box">
                      {value.image ? (
                        <div
                          className="pagelist__item--image"
                          style={{
                            backgroundImage: "url(" + value.image + ")",
                          }}
                        ></div>
                      ) : (
                        <div className="pagelist__item--noimage"></div>
                      )}
                    </div>
                    <div className="pagelist__item--content">
                      <div className="pagelist__item--title">
                        <h3>{value.title}</h3>
                      </div>
                      <div className="pagelist__item--description">
                        {value.text}
                      </div>
                    </div>
                  </div>
                  <div className="pagelist__item--svg"></div>
                </a>
              </div>
            );
          })}
        </div>
        {this.state.visible < values.length && (
          <div className="other-hits__loadmore">
            <button
              onClick={this.loadMore}
              type="button"
              className="btn-default loadmore"
            >
              <span className="sicon-arrow-right"></span>
              <span>{translate("searchresult.loadmore")}</span>
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default SearchLoadMore;
